import { KeywordMetrics } from '../software-services/search-engine-optimization/keywords/keyword-metrics';
import { CommitHistory } from '../software-services/change-log/commit-history';
import { TextMessageHistory } from '../software-services/website-package/text-message-history';
import { ChartData } from '../widgets/matrix-tools-chart/chart-data';

export class Website {
  domain: string;
  icon: string;

  // Google
  keywords: string[];
  targetedLastMonthKeywords: KeywordMetrics[];
  targetedLocalLastMonthKeywords: KeywordMetrics[];
  topTenAllTimeKeywords: KeywordMetrics[];
  topTenLastMonthKeywords: KeywordMetrics[];
  seoChartData: ChartData[];

  // GitHub
  commitHistory: CommitHistory[];
  commitHistoryChartData: ChartData;

  // Twilio
  textMessageHistory: TextMessageHistory[];

  // Client Data
  contractDatesChartData: ChartData;
}
